// VisitorDetailsContext.js
import React, { createContext, useContext, useState } from "react";

const VisitorDetailsContext = createContext(null);

export const VisitorDetailsProvider = ({ children }) => {
  const [selectedVisitor, setSelectedVisitor] = useState(null);

  return (
    <VisitorDetailsContext.Provider
      value={{ selectedVisitor, setSelectedVisitor }}
    >
      {children}
    </VisitorDetailsContext.Provider>
  );
};

export const useVisitorDetails = () => useContext(VisitorDetailsContext);
